export default "__VITE_ASSET__rHHuJERj__"